import { numberToCurrency } from '@hc-frontend/utils'
import getAvailableOptions from './utils/getAvailableOptions'

function getDeductibleOptions({ plans, plan, plansSTM, filterOptions, benefits }) {
  const deductibleOpts = filterOptions.deductible.values.reduce((result, current) => {
    result[current] = numberToCurrency(current)
    return result
  }, {})
  const deductibleAvailableOptions = getAvailableOptions({
    plans,
    plansSTM: plansSTM,
    currentPlan: plan,
    filters: [benefits.moop, benefits.coinsurance, benefits.coverage],
    currentFilter: benefits.deductible
  })

  return { options: deductibleOpts, availableOptions: deductibleAvailableOptions }
}

export default getDeductibleOptions
